import { COOKIE_BB_MARKET } from '@bridebook/web/app-shared/lib/i18n/cookies';
import { setCookie } from '@bridebook/web/app-shared/lib/utils/set-cookie';

export const setMarketCookie = (locale: string) => {
  setCookie(COOKIE_BB_MARKET, locale, 10);
};
